/* eslint-disable prefer-rest-params */

/* eslint-disable prefer-const */
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import * as Sentry from '@sentry/angular';

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from '@environments/environment';

import { loadRemoteStyle, removeRemoteStyle } from '@cxc/core/utils';

if (environment.PRODUCTION) {
  enableProdMode();
}
Sentry.init({
  dsn: environment.SENTRY_DSN,
  environment: environment.STAGE,
  release: environment.APP_VERSION,
  integrations: [Sentry.browserTracingIntegration()],
  tracePropagationTargets: ['localhost', /^\//],
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
  sendDefaultPii: true,
  beforeSend(event, _hint) {
    const allowedEnvs = ['production', 'qa', 'staging'];
    return allowedEnvs.includes(environment.STAGE!) ? event : null;
  },
});

// Pendo stuff
if (environment.ENABLE_PENDO) {
  (function (apiKey) {
    (function (p?: any, e?: any, n?: any, d?: any, o?: any) {
      let v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = o._q || [];
      v = [
        'initialize',
        'identify',
        'updateOptions',
        'pageLoad',
        'track',
        'trackAgent',
      ];
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? 'unshift' : 'push'](
                [m].concat([].slice.call(arguments, 0))
              );
            };
        })(v[w]);
      y = e.createElement(n);
      y.async = !0;
      y.src =
        'https://cdn.pendo.' +
        environment.PENDO_ENV +
        '/agent/static/' +
        apiKey +
        '/pendo.js';
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
  })(environment.PENDO_API_KEY);
}

(window as any).loadRemoteStyle = loadRemoteStyle;
(window as any).removeRemoteStyle = removeRemoteStyle;

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
